import apiClient from "../../apiClient";
import {
  FacilityCategory,
  FacilityCategoriesResponse,
  CreateFacilityCategoryRequest,
  UpdateFacilityCategoryRequest,
  PlayerFacility,
  PlayerFacilitiesResponse,
  CreatePlayerFacilityRequest,
  UpdatePlayerFacilityRequest,
} from "./type";

class FacilitiesService {
  async getCategories(params?: {
    skip?: number;
    limit?: number;
    name?: string;
  }): Promise<FacilityCategoriesResponse> {
    const response = await apiClient.get(`facilities-categories`, {
      params,
    });
    return response.data.data;
  }

  async getCategoryById(id: string): Promise<FacilityCategory> {
    const response = await apiClient.get(`facilities-categories/${id}`);
    return response.data;
  }

  async createCategory(
    data: CreateFacilityCategoryRequest,
  ): Promise<FacilityCategory> {
    const response = await apiClient.post(`facilities-categories`, data);
    return response.data;
  }

  async updateCategory(
    id: string,
    data: UpdateFacilityCategoryRequest,
  ): Promise<FacilityCategory> {
    const response = await apiClient.put(`facilities-categories/${id}`, data);
    return response.data;
  }

  async deleteCategory(id: string): Promise<void> {
    await apiClient.delete(`facilities-categories/${id}`);
  }

  // Player Facilities
  async getPlayerFacilities(params?: {
    skip?: number;
    limit?: number;
    playerId?: string;
    assignmentId?: string;
    status?: string;
  }): Promise<PlayerFacilitiesResponse> {
    const response = await apiClient.get(`player-facilities`, {
      params,
    });
    return response.data;
  }

  async getPlayerFacilityById(id: string): Promise<PlayerFacility> {
    const response = await apiClient.get(`player-facilities/${id}`);
    return response.data;
  }

  async createPlayerFacility(
    data: CreatePlayerFacilityRequest,
  ): Promise<PlayerFacility> {
    const response = await apiClient.post(`player-facilities`, data);
    return response.data;
  }

  async updatePlayerFacility(
    id: string,
    data: UpdatePlayerFacilityRequest,
  ): Promise<PlayerFacility> {
    const response = await apiClient.put(`player-facilities/${id}`, data);
    return response.data;
  }

  async deletePlayerFacility(id: string): Promise<void> {
    await apiClient.delete(`player-facilities/${id}`);
  }

  async approvePlayerFacility(id: string): Promise<PlayerFacility> {
    const response = await apiClient.post(`player-facilities/${id}/approve`);
    return response.data;
  }
}

export const facilitiesService = new FacilitiesService();
